module.exports = __webpack_public_path__ + "img/multiSlectedEle.d8efc142.svg";